import moment from "moment";
import "moment/locale/es";
import { dineroDisabledMask } from '../Components/Items'

moment.locale("es");

const reporteDIOTPdf = (values) => {
    const empresa = values.empresa
    const logoBiwo = values.logoBiwo;
    let filtrados = []

    if (values.tipoReporte === 1 && values.fechaReporte) {
        const fecha = moment(values.fechaReporte).locale('es').format('MMMM [de] YYYY');
        filtrados.push([
            { text: 'Tipo de Reporte:', style: 'subheader' },
            { text: 'Mensual', style: 'textoChico' }
        ]);
        filtrados.push([
            { text: 'Mes:', style: 'subheader' },
            { text: fecha, style: 'textoChico' }
        ]);
    }

    if (values.tipoReporte === 2 && values.periodo && values.periodo.length === 2) {
        const inicio = moment(values.periodo[0]).locale('es').format('LL');
        const fin = moment(values.periodo[1]).locale('es').format('LL');
        filtrados.push([
            { text: 'Tipo de Reporte:', style: 'subheader' },
            { text: 'Semestral', style: 'textoChico' }
        ]);
        filtrados.push([
            { text: 'Periodo:', style: 'subheader' },
            { text: `${inicio} al ${fin}`, style: 'textoChico' }
        ]);
    }

    if (filtrados.length === 0) {
        filtrados.push([
            { text: 'No tiene filtrados adicionales', style: 'subheader' },

            { text: '', style: 'textoChico' }
        ])
    }

    var dd = {
        footer: {
            image: 'logoBiwo', alignment: 'center', width: 80
        },
        content: [
            {
                style: 'tableExample',
                table: {
                    widths: ['18%', '52%', '30%'],
                    layout: {
                        defaultBorder: false,
                    },
                    body: [
                        [
                            {
                                //							rowSpan: 3,
                                border: [false, false, false, false],
                                image: 'logo',
                                fit: [80, 80]
                                //text: 'rowSpan: 3\n\nborder:\n[true, true, true, true]'
                            },
                            {
                                //	rowSpan: 2,
                                border: [false, false, false, false],
                                table: {
                                    headerRows: 1,
                                    widths: ['100%'],

                                    body: [
                                        [
                                            {
                                                text: empresa.nombreComercial ? empresa.nombreComercial : (empresa.persona ? empresa.nombre : empresa.nombre+' '+empresa.apellidoPaterno+' '+empresa.apellidoMaterno),
                                                style: "tableHeader"
                                            }
                                        ],
                                        [
                                            {
                                                text: "R.F.C: " + empresa.rfc,
                                                style: "textoChico",
                                                alignment: "center",
                                            },
                                        ],
                                        [
                                            {
                                                text: empresa.calle + ' ' +
                                                    empresa.numeroCalle + ' ' +
                                                    (empresa.numeroInterior ? empresa.numeroInterior : '')
                                                ,
                                                style: "textoChico",
                                                alignment: "center",
                                            },
                                        ],
                                        [
                                            {
                                                text: empresa.colonia.tipoAsentamiento + ' ' +
                                                    empresa.colonia.nombre + ' C.P. ' +
                                                    empresa.colonia.cp + ' ' +
                                                    empresa.municipio.nombre + ' ' +
                                                    empresa.estado.abreviatura + ' ' +
                                                    empresa.pais.abreviatura + ' '
                                                ,
                                                style: "textoChico",
                                                alignment: "center",
                                            },
                                        ],
                                        [{ text: 'DECLARACIÓN INFORMATIVA DE OPERACIONES CON TERCEROS (DIOT)', style: 'tableHeader' }],
                                    ]
                                },
                                layout: 'noBorders'
                            },
                            {
                                border: [false, false, false, false],
                                table: {
                                    headerRows: 1,
                                    widths: ['100%'],

                                    body: [
                                        [{ text: 'Fecha de Impresión:', style: 'subheader', alignment: 'center' }],
                                        [{ text: moment().locale('es').format('LL'), style: 'textoChico', alignment: 'center' }],
                                    ]
                                },
                                layout: 'noBorders'
                            },
                        ]

                    ]
                },
            },
            { text: 'Datos de filtrado:' },
            {
                style: 'tableExample',
                table: {
                    widths: ['20%', '80%'],
                    layout: {
                        defaultBorder: false,
                    },

                    body: filtrados,
                },
                layout: {
                    hLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.body.length) ? 1 : 1;
                    },
                    vLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.widths.length) ? 1 : 1;
                    },
                    hLineColor: function (i, node) {
                        return '#adaaaa';
                    },
                    vLineColor: function (i, node) {
                        return '#adaaaa';
                    },
                    hLineStyle: function (i, node) {
                        if (i === 0 || i === node.table.body.length) {
                            return null;
                        }
                        return { dash: { length: 2, space: 1 } };
                    },
                    vLineStyle: function (i, node) {
                        if (i === 0 || i === node.table.widths.length) {
                            return null;
                        }
                        return { dash: { length: 2 } };
                    },
                    // paddingLeft: function(i, node) { return 4; },
                    // paddingRight: function(i, node) { return 4; },
                    // paddingTop: function(i, node) { return 2; },
                    // paddingBottom: function(i, node) { return 2; },
                    // fillColor: function (i, node) { return null; }
                }

            },

            {
                style: 'tableExample',
                table: {
                    widths: ['14%', '18%', '7%', '7%', '10%', '10%', '10%', '10%', '8%', '6%'],
                    body: [
                        [
                            { text: 'RFC', style: 'tituloTabla' },
                            { text: 'Proveedor', style: 'tituloTabla' },
                            { text: 'Tipo Tercero', style: 'tituloTabla' },
                            { text: 'Tipo Operación', style: 'tituloTabla' },
                            { text: 'Base IVA 16%', style: 'tituloTabla' },
                            { text: 'IVA Acreditable', style: 'tituloTabla' },
                            { text: 'IVA No Acreditable', style: 'tituloTabla' },
                            { text: 'Retención IVA', style: 'tituloTabla' },
                            { text: 'Exento', style: 'tituloTabla' },
                            { text: 'Efectos', style: 'tituloTabla' },
                        ],
                        ...values.diot.map((row) => {
                            return [
                                { text: row.rfc || '', style: 'textoTabla' },
                                { text: row.nombreProveedor || '', style: 'textoTabla' },
                                { text: String(row.tipoTercero || '').padStart(2, '0'), style: 'textoTabla', alignment: 'center' },
                                { text: String(row.tipoOperacion || '').padStart(2, '0'), style: 'textoTabla', alignment: 'center' },
                                { text: dineroDisabledMask(row.monto12), style: 'textoTabla', alignment: 'right' },
                                { text: dineroDisabledMask(row.ivaCampo22), style: 'textoTabla', alignment: 'right' },
                                { text: dineroDisabledMask(row.ivaNCampo38), style: 'textoTabla', alignment: 'right' },
                                { text: dineroDisabledMask(row.ivaRetenido48), style: 'textoTabla', alignment: 'right' },
                                { text: dineroDisabledMask(row.monto50), style: 'textoTabla', alignment: 'right' },
                                { text: row.campo54 || '', style: 'textoTabla', alignment: 'center' }
                            ];
                        }),
                    ],
                },
                layout: {
                    fillColor: (rowIndex) => (rowIndex === 0 ? '#cccccc' : rowIndex % 2 === 0 ? '#e8e8e8' : '#ffffff'),
                    hLineWidth: () => 1,
                    vLineWidth: () => 1,
                    hLineColor: () => '#adaaaa',
                    vLineColor: () => '#adaaaa',
                    hLineStyle: (i, node) => (i === 0 || i === node.table.body.length ? null : { dash: { length: 2, space: 1 } }),
                    vLineStyle: (i, node) => (i === 0 || i === node.table.widths.length ? null : { dash: { length: 2 } }),
                },
            }

        ],
        images: {
            logo: empresa.logo.base64Completa,
            logoBiwo: logoBiwo.base64Completa,
        },
        styles: {
            header: {
                fontSize: 9,
                bold: true,
            },
            subheader: {
                fontSize: 8,
                bold: true,
            },
            tableExample: {
                margin: [0, 5, 0, 5]
            },
            tablaSinMargen: {
                margin: [0, 0, 0, 0]
            },
            tableHeader: {
                bold: true,
                fontSize: 12,
                color: 'black',
                alignment: 'center'
            },
            textoChico: {
                fontSize: 8
            },
            tituloTabla: {
                fontSize: 8,
                bold: true,
                fillColor: '#cccccc',
                style: 'subheader',
                alignment: 'center',
                border: true
            },
            textoTabla: {
                fontSize: 8,
                italics: false
            },
            totalesTabla: {
                fontSize: 8,
                bold: true,
                italics: false,
                fillColor: '#cccccc',
            }
        },
        pageSize: 'LETTER',
        pageMargins: [20, 20, 20, 60],
    }
    return dd;
};


export default reporteDIOTPdf;